import { setToken, getToken, removeToken } from '@/utils/auth';
import api from '@/http/api'

export default {
	state: {
		perms: [], // 用户权限标识集合
		token: getToken(),
	},
	getters: {
   
	},
	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token;
		},
	},
	actions: {
		// 登录
		Login({ commit }, data) {
			return new Promise((resolve, reject) => {
				api.login.login(data).then(res => {
					const data = res.data;
					const userData = data;

					// 保存用户到本地会话
					sessionStorage.setItem('user', JSON.stringify(userData))

					setToken(data.token);

					commit('SET_TOKEN', data.token);
					
					resolve();
				})
				.catch(error => {
					reject(error);
				});
			});
		},
		// 获取用户信息
		GetNavByRole({ commit, state },data) {
			return new Promise((resolve, reject) => {
				api.login.getNavByRole(data).then(response => {
					resolve(response);
				}).catch(error => {
					reject(error);
				});
			});
		},
		// 登出
		LogOut({ commit, state }) {
			return new Promise((resolve, reject) => {
				api.login.logout().then(() => {
					commit('SET_TOKEN', '');
					commit('SET_NAVTREE', []);
					removeToken();
					resolve();
				}).catch(error => {
					reject(error);
				});
			});
		},
		// 前端 登出
		FedLogOut({ commit }) {
			return new Promise(resolve => {
				commit('SET_TOKEN', '');
				removeToken();
				resolve();
			});
		},
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js